import React from 'react';
import PropTypes from 'prop-types';

function GameName({ game }) {
  return (
    <div className='game-card-name game-name-title' title={game.name}>
      {game.name}
    </div>
  );
}

GameName.propTypes = {
  game: PropTypes.shape({
    name: PropTypes.string
  }).isRequired
};

export default GameName;
